function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#FFF",
  d: "M19.4 38.4l.6 1.2c.1.3.3.4.6.4.2 0 .5-.1.6-.4l.6-1.2c.8-1.5 1.2-3.2 1.2-4.9V12a15 15 0 0 0-.6-4.2l-1.8-5.4-1.9 5.4c-.4 1.4-.6 2.8-.6 4.2v21.5c0 1.7.4 3.4 1.3 5z"
}), React.createElement("path", {
  fill: "#46C3D7",
  d: "M19.3 36.5l.1.1c.3.4.7.6 1.1.7h.2a1.4 1.4 0 0 0 1.2-.8l.1-.6h-.1l-.3.4h-.1c-.3.3-.5.4-.8.4h-.2c-.3 0-.6-.1-.8-.3l-.1-.1-.3-.4c0-.1-.1 0-.1 0l.1.6"
}), React.createElement("path", {
  fill: "#145569",
  d: "M26.7 26.6a7 7 0 0 0 2 0h.3l-.1-2v-1c0-.3-.4-.6-.8-.7h-.7c-.5 0-.8.4-.8.8l-.2 2.6v.3h.3z"
}), React.createElement("path", {
  fill: "#145569",
  d: "M26.5 27.1h.2a7 7 0 0 0 2 0h.1c.2 0 .2-.1.2-.2v-.3h-.3a7 7 0 0 1-2 0h-.3v.3c0 .1 0 .2.2.2M31.3 24.1h.2a7 7 0 0 0 2 0h.1c.1 0 .2 0 .2-.2v-.3h-.3a7 7 0 0 1-2 0H31v.3l.2.2"
}), React.createElement("path", {
  fill: "#145569",
  d: "M31.5 23.6a7 7 0 0 0 2 0h.3l-.1-2.2v-.7c-.1-.4-.4-.8-.9-.8h-.7c-.4 0-.7.3-.7.8l-.2 2.3v.6h.3zM14.5 26.6H12l.2-2v-1c0-.4.4-.7.8-.7h.7c.4 0 .8.3.8.7l.2 2.6v.4h-.3z"
}), React.createElement("path", {
  fill: "#145569",
  d: "M14.6 27h-.1c-.7.2-1.4.2-2 0h-.2a.2.2 0 0 1-.2-.1v-.4h.4c.6.2 1.3.2 2 0h.3v.4s0 .2-.2.2M9.8 24h-.1c-.7.2-1.4.2-2 0h-.2a.2.2 0 0 1-.2-.1v-.4h.4c.6.2 1.3.2 2 0h.3v.4s0 .2-.2.2"
}), React.createElement("path", {
  fill: "#145569",
  d: "M9.7 23.6H7.3l.2-2.3v-.7c0-.4.4-.7.8-.7H9c.4 0 .8.3.8.7l.1 2.4v.5h-.2z"
}), React.createElement("path", {
  fill: "#50C364",
  d: "M41 13.9l-15.6 4.9-2.4.7V28l2.4-1.6 14.8-9.9z"
}), React.createElement("path", {
  fill: "#B5E4BD",
  d: "M40.2 16.5L23 28v-1l17.6-11.7z"
}), React.createElement("path", {
  fill: "#50C364",
  d: "M.2 13.9l15.6 4.8 2.3.8V28l-2.3-1.6L.9 16.5z"
}), React.createElement("path", {
  fill: "#B5E4BD",
  d: "M.9 16.5L18.1 28v-1.1L.5 15.3z"
}), React.createElement("path", {
  fill: "#50C364",
  d: "M13.3.3l4.8 2 2.2.8-.1 4.5-2.1-1.7-4.6-4.1z"
}), React.createElement("path", {
  fill: "#B5E4BD",
  d: "M13.5 1.8l6.7 5.8v-.8L13.4.9z"
}), React.createElement("path", {
  fill: "#50C364",
  d: "M27.9.3l-4.8 2-2.2.8.1 4.5 2.1-1.7 4.6-4.1z"
}), React.createElement("path", {
  fill: "#B5E4BD",
  d: "M27.7 1.8L21 7.6v-.8L27.8.9zM20.6 9.5A.5.5 0 0 0 21 9L20.8.2c0-.1 0-.2-.2-.2l-.2.2L20 9a.4.4 0 0 0 .5.5z"
}));

var SvgPlane2 = function SvgPlane2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 41 40",
    width: 41,
    height: 40,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlane2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plane2.cc688c29.svg";
export { ForwardRef as ReactComponent };